import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

export const useDisneySelectionModalControls = () => {
    const { isModalOpen, closeModal, editModal, openModal } = useBrowserModalControls('disney-selection');

    return {
        isDisneySelectionModalOpen: isModalOpen,
        openDisneySelectionModal: () => openModal(),
        closeDisneySelectionModal: closeModal,
        editDisneySelectionModal: editModal,
    };
};
